var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-none d-md-block fs-12 m-2 ce-breadcrumbs align-items-center"},[_vm._l((_vm.slots),function(h,i){return [(i !== 0)?_c('ad-icon-chevron',{key:i + 'icon',attrs:{"rotate":"270","size":"xxs"}}):_vm._e(),_c('ce-node-renderer',{key:i + 'node',attrs:{"node":h}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }